module.exports = __webpack_public_path__ + "male-user-icon.c4ba6b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/male-user-icon.png
// module id = njhv
// module chunks = 0